import axios from "axios";
import { UrlBundles, UserInfo } from "Libs/core";
import _ from "lodash";
import * as a from "../types/actions.types";
import * as g from "../types/getters.types";
import * as m from "../types/mutations.types";

const communications = {
    namespaced: true,
    state: {
        communicationsList: [],
        loading: false
    },
    getters: {
        [g.GET_COMMUNICATIONS_LOADING](state) {
            return state.loading;
        },
        [g.GET_COMMUNICATIONS_LIST](state) {
            return state.communicationsList;
        },              
    },
    mutations: {
        [m.SET_COMMUNICATIONS_LOADING](state, payload) {
            state.loading = payload;
        },
        [m.SET_COMMUNICATIONS_LIST](state, payload) {
            state.communicationsList = payload;
        }
    },
    actions: {       
        [a.LOAD_COMMUNICATIONS]({ commit }, payload) {
            commit(m.SET_COMMUNICATIONS_LOADING, true);
            return axios.get(UrlBundles.passepartoutCommunicationsApi + "/GetFilteredCommunications?destination=" + payload.destination).then((result) => {
                commit(m.SET_COMMUNICATIONS_LIST, result.data || []);
                commit(m.SET_COMMUNICATIONS_LOADING, false);
            });
        },     
    },
};

export default communications;
